import styled from 'styled-components';

export const MessageBoxContainer = styled.div`
    .message-box-outer-container {
        display: flex;
        justify-content: center;

        .message-box-inner-container {
            background-color: #ebf4f7;
            color: #5a5a5a;
            padding: 15px 10px 15px 10px;
            border: 2px solid #007896;
            width: 100%;
            max-width: 768px;
            font-size: 11px;
            display: flex;

            > div {
                padding: 0 5px 0 5px;
            }

            .chat-bubbles {
                svg {
                    height: 16px;
                    width: 16px;
                }

                path {
                    fill: #007896;
                }
            }

            .close-x {
                cursor: pointer;
                margin-left: auto;

                svg {
                    height: 12px;
                    width: 12px;

                    [id^='close-x'] {
                        fill: grey;
                    }
                }
            }
        }
    }
`;
